var tri = require("tripartite"); var t = "<div class=\"cancel-mask\">\n\tAttempting to Cancel Operation\t\n<\/div>"; 
module.exports = tri.addTemplate("@webhandle/event-notification-panel/panels/cancel-mask", t); 